import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage } from '../../WifiManagementBlockSlice';
import NetworkItem from '../../Partials/NetworkItem/NetworkItem';

const GuestNetworkPage = (props) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isShowPassword, setIsShowPassword] = useState(false);

    useEffect(() => {

    }, []);

    return (
        <div className='guest-network-page'>

            <div className='title'> רשת האורחים שלך </div>

                {
                    props.guestNetworks &&
                    props.guestNetworks.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <NetworkItem item={item} isDisplayNetworkTypes={true} />
                            </React.Fragment>                            
                        );
                    })
                }

        </div>
    );

};

const mapStateToProps = (state) => {
    return {
        guestNetworks: state.wifiManagementBlock?.networkWiFis.filter(x=> x.type == 'Guest')
    };
};

const mapDispatchToProps = {
    goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(GuestNetworkPage);